module.exports = __webpack_public_path__ + "static/media/ImporterStep1.53bbeaf1.svg";